import { render, staticRenderFns } from "./Universals.vue?vue&type=template&id=28639dc5"
import script from "./Universals.vue?vue&type=script&lang=js"
export * from "./Universals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports